module.exports = __webpack_public_path__ + "img/je.e170f442.svg";